import {
  CatalogRecord,
  CatalogRecordAvailability,
  CatalogRecordAvailabilityBranch,
  CatalogRecordAvailabilityDetail,
  CirculationItem,
  CleanedMarcDetails,
  MarcDetails
} from '@store/catalog/catalog.types';
import {FALLBACK_MATERIAL_TYPE} from '@aviary/store/common/common.fallback';

export const FALLBACK_CLEANED_MARC_DETAILS: CleanedMarcDetails = {
  publicationDate: ''
}

export const FALLBACK_MARC_DETAILS: MarcDetails = {
  title: '',
  subtitle: '',
  statementOfResponsibility: '',
  author: '',
  otherAuthors: [],
  summary: '',
  languageCode: '',
  physicalDescription: '',
  publisher: '',
  publicationDate: '',
  publicationLocation: '',
  edition: '',
  subjects: [],
  genres: [],
  notes: [],
  callNumbers: {},
  identifiers: {},
  controlNumbers: {},
  clean: FALLBACK_CLEANED_MARC_DETAILS,
  marcRecordStrings: [],
  seriesString: '',
}

export const FALLBACK_CATALOG_RECORD_AVAILABILITY: CatalogRecordAvailability = {
  availableCount: 0,
  onHoldCount: 0,
  totalCopies: 0,
  opacVisibleCopies: 0,
  circulatingCopies: 0,
  holdsInQueue: 0,
  availableAtPatronBranch: 0,
  callNumber: '',
  collectionName: ''
}


export const FALLBACK_CIRCULATION_ITEM: CirculationItem = {
  barcode: '',
  callNumber: '',
  shelfName: '',
  status: 'IN_LIBRARY',
  tempLocation: '',
  currentBranchId: 0,
  homeBranchId: 0,
  assignedBranchId: 0,
  collectionName: '',
  collectionAbbreviation: '',
  fromIll: false,
}


export const FALLBACK_CATALOG_RECORD_AVAILABILITY_BRANCH: CatalogRecordAvailabilityBranch = {
  patronHomeBranch: false,
  availableCount: 0,
  opacVisibleCopies: 0,
  branchId: 0,
  branchName: '',
  circulationItems: []
}

export const FALLBACK_CATALOG_RECORD_AVAILABILITY_DETAIL: CatalogRecordAvailabilityDetail = {
  branchAvailability: [],
  totals: FALLBACK_CATALOG_RECORD_AVAILABILITY
}

export const FALLBACK_CATALOG_RECORD: CatalogRecord = {
  id: 0,
  organizationId: 0,
  marcRecord: '',
  title: '',
  description: '',
  author: '',
  physicalDescription: '',
  identifier: '',
  imageUrl: '',
  identifierType: 'ISBN',
  fromIll: false,

  marcDetails: FALLBACK_MARC_DETAILS,
  materialType: FALLBACK_MATERIAL_TYPE,
  availability: FALLBACK_CATALOG_RECORD_AVAILABILITY
}
